export const materialsKeys = {
    all: ['materials'] as const,
    previews: (materialId: number) => [...materialsKeys.all, 'previews', materialId] as const,
    hero: (world: string, isLoggedIn: boolean) => [...materialsKeys.all, 'hero', world, isLoggedIn] as const,
    byId: (materialId: number) => [...materialsKeys.all, 'by-id', materialId] as const,
    // AB TEST - 1406 (remove on either accept or reject)
    purchaseCount30d: (materialId: number, world: string) =>
        [...materialsKeys.all, 'purchase-count-30d', materialId, world] as const
} as const;

// Invalidations:
// materialsKeys.hero  → read-only; no mutation in the app changes the hero partitions.
//                       Inherits the global staleTime: 0, so every mount refetches.
// materialsKeys.purchaseCount30d → no invalidation. The only writer is a purchase, which the backend
//                       counts asynchronously in its indexer, so the number is never live anyway. The
//                       value is read as a bucket (10/25/50/...), so a purchase moves it only when it
//                       crosses a boundary, and the buyer is leaving the page regardless. World and
//                       material are part of the key, so switching either reads its own entry.

// Shared fetchers already migrated:
// queryHeroMaterials (src/api/materials/query-hero-materials.ts) → useHeroMaterials
